import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';

@Pipe({
  name: 'recordTypeIcon'
})
export class RecordTypeIconPipe implements PipeTransform {

  constructor(private commonService: CommonService) {}

  transform(value: any): any {
    if (value) {
      return this.commonService.getIconForRecordType((value).toString().toUpperCase());
    }
    return 'far fa-file-alt';
  }

}
